import destinations from '@/locales/destinations.json';

export default function getDestination(
  input: string
): (typeof destinations)[number] | undefined {
  return destinations.find(d => d.name === input || d.iso === input);
}
